module.exports = __webpack_public_path__ + "static/img/bg1.3f859f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/midAutumnRecall/recall/bg1.png
// module id = H2Dm
// module chunks = 1